// WHEN an opened picture is allowed to take the Briefing strip (busy-my-web#392).
//
// Saffet: "There is a problem with the Briefing it is displaying the photo I ticked not the
// Briefing and Breadcrumbs". The image briefing used to be read FIRST of every subject — ahead of
// the open inbox, the open pack, the open story — so while a picture was open the strip was about
// that picture and the breadcrumb trail was gone (an image briefing has no depth, so
// lib/briefings/trail.js draws nothing over it). The way back out disappeared with it.
//
// The rule now: an opened picture never takes the strip away from a PLACE the user is standing in.
// A story, a Research Pack and the mailbox are places — they are walked into, they carry a trail,
// and the trail is the way back. Everything else the strip can be about (a search, the selection
// you have ticked, a comparison) is a subject that describes the middle rather than a place with a
// way out of it, and there the picture is still the most immediate thing on screen and still wins.
//
// So on home, opening a search photo briefs the picture exactly as before — that is where the
// image briefing earns its keep — and inside a story or a pack the strip keeps describing the
// story or the pack, with its crumbs, while the picture is open. Closing the picture changes
// nothing about which briefing is shown, which is why "closing restores the previous briefing"
// costs no code at all.

/**
 * The briefings that are a PLACE — a subject the user navigated INTO and can navigate back out of.
 * These are exactly the kinds lib/briefings/trail.js is prepared to draw a breadcrumb over, which
 * is not a coincidence: the report is about losing the crumbs.
 */
export const PLACE_KINDS = ['story', 'pack', 'emails']

/**
 * Is this briefing a place the user is working in?
 *
 * @param {object|null} briefing the built briefing, or null
 * @returns {boolean}
 */
export function isPlaceBriefing(briefing) {
  return !!briefing && PLACE_KINDS.includes(briefing.kind)
}

/**
 * Which of the two the strip shows: the opened picture, or the subject underneath it.
 *
 * @param {object|null} image   the image briefing for the open preview, or null when none is open
 * @param {object|null} subject the briefing the strip would show with no picture open
 * @returns {object|null} the briefing to show
 */
export function preferBriefing(image, subject) {
  if (!image) return subject || null
  return isPlaceBriefing(subject) ? subject : image
}
